import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import NavComponent from './Components/NavComponenet.js';
import DishesComponent from './Components/DishesComponent.js';
import BusinesssComponent from './Components/BusinessComponent.js';
import { findBranchesInLocations, getBranchDishesByBranchID, getTenMatchingWords } from './API';

(() => {
    const container = document.getElementsByClassName('container')[0]; // Screen Display Container
    const appData = {
        searchData : {
            place_id: NaN,
            placeName: '',
            by: ''
        },
        businesses: []
    }


    const showBusinesses = (placeName, by) => {
        // If list of businesses in the array is empty and the is no search made - Default Requet or Display
        if (!placeName && (!appData.businesses || !appData.businesses.length)) {
            BusinesssComponent(container, 
            { businesses: appData.businesses, findBranchesInLocations, searchData: appData.searchData});
           console.log('AA', appData.businesses); 
        }// If search requet is made
        else if (placeName) {
            console.log('BB',placeName,'data:', appData.businesses); 
        BusinesssComponent(container,
        { businesses: appData.businesses, findBranchesInLocations, searchData: appData.searchData});
        // If there are businesses in the list but no search request made
        } else {
            console.log('CC', appData.businesses); 
            BusinesssComponent(container, { businesses: appData.businesses, searchData: appData.searchData });
        }
    }

    /** -MAIN- **/
    (() => {
        NavComponent(document.getElementById('header'), { 
            links: ['Register Your Business', 'About', 'Contacts'],
            searchData: appData.searchData,
            showBusinesses, getTenMatchingWords
        });
        showBusinesses();
    })();
    
    /** -MAIN- **/
    window.addEventListener('hashchange', (e) => {
        const path = location.hash.substring(2);
        const splitPath = path.split('/');
        if (splitPath[0] == "menu") { // Display the menu for the business brand of the provided ID
            DishesComponent(container, { branchID: splitPath[1], getBranchDishes: getBranchDishesByBranchID });
        } else if (!location.hash) showBusinesses(); // Must query navigation of the last keyword searches
    });
})();
